// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"3dc7f9a6","484":"d050e7eb","643":"0e02bb73","674":"2ff99a3f","734":"a484f421"}[chunkId] + ".chunk.js";
};